import { connect } from 'react-redux'
import { NavBar as UI } from './NavBar'

import { getCountries, setCountry } from './actions'
import { ReduxState } from '../../global/types'

const mapStateToProps = (state: ReduxState) => ({
  countries: Object.keys(state.countries.data).map(
    key => state.countries.data[key],
  ),
  selectedCountryId: state.countries.selected,
})

const mapDispatchToProps = {
  getCountries,
  setCountry,
}

export const NavBar = connect(mapStateToProps, mapDispatchToProps)(UI)
